module.exports = __webpack_public_path__ + "static/media/InVirtual-Sports.a8578bb6.svg";